import React from 'react'

import { PSL, SLR } from 'common/const/marketplace'
import { BANKRATE, NERDWALLET, WSJ } from 'components/featured-lender-banner/const'

import sofiLogo from '../assets/sofi-logo.svg'
import earnestLogo from '../assets/earnest-logo.svg'
import casLogo from '../assets/cas-logo.svg'
import sallieMaeLogo from '../assets/sallie-mae-logo.svg'

export const LOGOS = {
  sofi: sofiLogo,
  earnest: earnestLogo,
  cas: casLogo,
  'sallie-mae': sallieMaeLogo,
}

export const RATING_LINK = {
  [WSJ]: 'Buy Side rating',
  [BANKRATE]: 'Bankrate score',
  [NERDWALLET]: 'Nerdwallet rating',
}

export const RATING_TOOLTIP_BODY = {
  [NERDWALLET]: `NerdWallet's ratings are determined by our editorial team. The scoring formula for student
          loan products takes into account more than 50 data points across multiple categories,
          including repayment options, customer service, lender transparency, loan eligibility and
          underwriting criteria.`,
  [WSJ]: `Buy Side lender ratings are evaluated by our editorial team with the help of our loan operations team. 
          We collected thousands of data points on dozens of lenders for personal loans, mortgages, and student loans. 
          Specific criteria vary by loan type, but generally include interest rates, loan terms,
          eligibility requirements, transparency, funding times, repayment options, fees, discounts,
          customer service, cosigner options, and more.`,
  [BANKRATE]: `Bankrate lender ratings are evaluated by our editorial team with the help of our loan operations team. 
          We collected thousands of data points on dozens of lenders for personal loans, mortgages, and student loans. 
          Specific criteria vary by loan type, but generally include interest rates, loan terms,
          eligibility requirements, transparency, funding times, repayment options, fees, discounts,
          customer service, cosigner options, and more.`,
}

export const BELOW_LOGO_TEXT = {
  [SLR]: (
    <>
      Student Loan <br /> Refinancing
    </>
  ),
  [PSL]: (
    <>
      Private Student <br /> Loan
    </>
  ),
}
